<cm-inspector-section>
    <ng-container cm-title>Planar Curve </ng-container>
    <ng-container cm-content>
        <cm-spline-curve
            [controlPoints]="$splineControlPoints()"
            [curvePoints]="$splineCurvePoints()"
            [otherPathsPoints]="$otherSplinePathsPoints()"
            [width]="$widthPx()"
            [height]="$heightPx()"
            (onBeginControlPointDrag)="beginControlPointDrag()"
            (onEndControlPointDrag)="endControlPointDrag()"
            (onControlPointChanged)="changeControlPoint($event.pointId, $event.point)"
            (onBackgroundClicked)="handleBackgroundClicked($event)"
            (onBackgroundMouseDown)="handleBackgroundMouseDown()"
            (onBackgroundMouseUp)="handleBackgroundMouseUp()"
            (onMouseMoved)="handleMouseMoved($event)"
            (onSplineClicked)="handleSplineClicked($event)"
            [(selectedControlPoint)]="$selectedControlPoint"
            [(hoveredControlPoint)]="$hoveredControlPoint"
            (onWheelMoved)="handleZoomChanged($event)"
        >
            <ng-content cm-background>
                <svg #background class="cm-background"></svg>
            </ng-content>
        </cm-spline-curve>
        <cm-value-slot [node]="$node()" [key]="'resolution'" [label]="'Resolution (cm)'"></cm-value-slot>

        @let selectedIdx = $selectedControlPoint();
        @if (selectedIdx !== undefined) {
            <div class="cm-xy-slots">
                <cm-value-slot [node]="$node()" [key]="'controlPoints'" [subKey]="[selectedIdx, 'position', 0]" [label]="'X (cm)'"></cm-value-slot>
                <cm-value-slot [node]="$node()" [key]="'controlPoints'" [subKey]="[selectedIdx, 'position', 1]" [label]="'Y (cm)'"></cm-value-slot>
            </div>
            <cm-value-slot
                [node]="$node()"
                [key]="'controlPoints'"
                [subKey]="[selectedIdx, 'corner']"
                [label]="'Corner'"
                [schema]="$booleanSchema()"
            ></cm-value-slot>
            <cm-value-slot
                [node]="$node()"
                [key]="'controlPoints'"
                [subKey]="[selectedIdx, 'sectionBreak']"
                [label]="'Section Break'"
                [schema]="$booleanSchema()"
            ></cm-value-slot>
            <cm-button class="cm-action-button" (click)="deleteControlPoint()">
                <ng-container cm-text> Delete </ng-container>
            </cm-button>
        }

        <cm-value-slot [node]="$node()" [key]="'closed'" [label]="'Close Path'"></cm-value-slot>

        <cm-button class="cm-action-button" (click)="toggleDrawingMode()">
            <ng-container cm-text> Draw </ng-container>
        </cm-button>

        <cm-button class="cm-action-button" (click)="addControlPoint()">
            <ng-container cm-text> Add control point </ng-container>
        </cm-button>

        <cm-button class="cm-action-button" (click)="deleteAllControlPoints()">
            <ng-container cm-text> Delete all control points </ng-container>
        </cm-button>

        <cm-button class="cm-action-button" (click)="flipControlPoints()">
            <ng-container cm-text> Flip control points </ng-container>
        </cm-button>

        <cm-button class="cm-action-button" (click)="rotateControlPoints(90)">
            <ng-container cm-text> Rotate control points CW 90 deg </ng-container>
        </cm-button>

        <cm-button class="cm-action-button" (click)="rotateControlPoints(-90)">
            <ng-container cm-text> Rotate control points CCW 90 deg </ng-container>
        </cm-button>
    </ng-container>
</cm-inspector-section>
